import locales from '../../content.json';

type LocaleDictionary = Record<string, string>;
type LocalesDictionary = Record<string, LocaleDictionary>;

interface CreateLocaleTextGetterOptions {
  fallbackLang?: string;
  lang?: string;
  localeMap?: LocalesDictionary;
}

const DEFAULT_LANG = 'en';

export const createLocaleTextGetter = (options: CreateLocaleTextGetterOptions = {}) => {
  const { fallbackLang = DEFAULT_LANG, localeMap = locales as LocalesDictionary } = options;

  const currentLang =
    options.lang ?? (typeof window !== 'undefined' && window.userLang ? window.userLang : DEFAULT_LANG);

  const currentLocale = localeMap[currentLang] || {};
  const fallbackLocale = localeMap[fallbackLang] || {};

  return (key: string): string => currentLocale[key] || fallbackLocale[key] || '';
};
